import { apiClient, type ApiResponse } from './baseServices'
import type { LoginRequest, AuthResult, UserProfile } from '@/types/auth'

export type { LoginRequest, AuthResult, UserProfile }

// ── Auth Service ─────────────────────────────────────────────────────────────

export const authService = {
  async login(credentials: LoginRequest): Promise<ApiResponse<AuthResult>> {
    const { data } = await apiClient.post<ApiResponse<AuthResult>>('/auth/login', credentials)
    return data
  },

  async refresh(refreshToken: string): Promise<ApiResponse<AuthResult>> {
    const { data } = await apiClient.post<ApiResponse<AuthResult>>('/auth/refresh', {
      refreshToken
    })
    return data
  },

  async logout(refreshToken: string): Promise<ApiResponse<void>> {
    const { data } = await apiClient.post<ApiResponse<void>>('/auth/logout', { refreshToken })
    return data
  },

  async getCurrentUser(): Promise<ApiResponse<UserProfile>> {
    const { data } = await apiClient.get<ApiResponse<UserProfile>>('/users/me')
    return data
  },

  async getMyPermissions(): Promise<ApiResponse<string[]>> {
    const { data } = await apiClient.get<ApiResponse<string[]>>('/users/me/permissions')
    return data
  },

  async forgotPassword(email: string): Promise<ApiResponse<void>> {
    const { data } = await apiClient.post<ApiResponse<void>>('/auth/forgot-password', { email })
    return data
  },

  async resetPassword(token: string, newPassword: string): Promise<ApiResponse<void>> {
    const { data } = await apiClient.post<ApiResponse<void>>('/auth/reset-password', {
      token,
      newPassword
    })
    return data
  }
}
